module.exports = __webpack_public_path__ + "static/logo-3718706690ded8ecb91c2d39a9ef4c37.png";